export const notjunk = "fSa";
export default {notjunk};